export default __webpack_public_path__ + "static/media/stop.a908bafa.svg";